import React, { useEffect, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { trackFunnelEvent } from "../utils/funnelTracking";
import "../components/ajp/JourneyAlertConversion.css";

export default function JourneyAlertThankYou() {
  const location = useLocation();
  const receipt = useMemo(() => {
    if (location.state) return location.state;
    try { return JSON.parse(window.sessionStorage.getItem("ajp_journey_alert_receipt") || "{}"); } catch { return {}; }
  }, [location.state]);
  useEffect(() => { trackFunnelEvent("journey_alert_thank_you_view", { brand: "planner", airport: receipt.airportCode, subscription_id: receipt.subscriptionId }); }, [receipt.airportCode, receipt.subscriptionId]);
  const journeyTime = receipt.time ? new Intl.DateTimeFormat("en-GB", { dateStyle: "medium", timeStyle: "short" }).format(new Date(receipt.time)) : "We’ll match it as data becomes available";
  const airportSlug = ({ LHR: "heathrow", LGW: "gatwick", LTN: "luton", STN: "stansted", MAN: "manchester-airport", EMA: "east-midlands-airport" })[receipt.airportCode] || "";
  return <main className="ajp-alert-thankyou">
    <Helmet><title>Journey alert registered | Airport Journey Planner</title><meta name="robots" content="noindex,nofollow" /></Helmet>
    <section className="ajp-alert-confirmation">
      <header className="ajp-alert-confirmation-hero">
        <p className="ajp-alert-kicker">Email verified · Journey monitoring ready</p>
        <h1>Your journey alert is registered</h1>
        <p>We’ll monitor the available airport, flight, road, rail, weather, terminal and queue signals for this journey and email meaningful changes.</p>
      </header>
      <div className="ajp-alert-confirmation-body">
        <div className="ajp-alert-confirmation-grid">
          <article><span>Airport</span><strong>{receipt.airportName || receipt.airportCode || "Your airport"}</strong></article>
          <article><span>Flight</span><strong>{receipt.flight || "To be matched"}</strong></article>
          <article><span>Starting from</span><strong>{receipt.postcode || "Not provided"}</strong></article>
          <article><span>Journey date &amp; time</span><strong>{journeyTime}</strong></article>
        </div>
        <div className="ajp-alert-confirmation-next">
          <article><strong>1. We keep watch</strong>Prepared journey conditions are checked as your travel time approaches.</article>
          <article><strong>2. We match updates</strong>Where available, signals are matched to your airport, flight and journey context.</article>
          <article><strong>3. We email changes</strong>Significant updates go to <strong>{receipt.email || "your verified email"}.</strong></article>
        </div>
        <div className="ajp-alert-confirmation-actions">
          <Link to="/" className="ajp-alert-primary">Return to Airport Journey Planner</Link>
          {airportSlug ? <Link to={`/${airportSlug}`} className="ajp-alert-secondary">View current airport conditions</Link> : null}
        </div>
      </div>
    </section>
  </main>;
}
